import {
  api_email_settings_path,
  api_gift_subscription_settings_path,
  api_update_email_settings_path,
  api_user_account_path,
} from '@routes';
import { getJWT } from '@utils/jwtHelper';

import { SuccessResponse } from '../interfaces';
import request from './request';

export const USER_ACCOUNT_SETTINGS_KEY = 'user_dashboard_settings_key';
export const GIFT_SUBSCRIPTION_SETTINGS_KEY = 'gift_subscription_settings_key';
export const USER_EMAIL_SETTINGS_KEY = 'user_email_settings_key';
export const PRIVACY_SETTINGS_KEY = 'privacy_settings_key';

export interface SettingsResponse {
  canResumeSubscription: boolean;
  canRestartSubscription: boolean;
  canUpdatePayment: boolean;
  canViewPaymentHistory: boolean;
  eligibleToUpgrade: boolean;
  isRevcatSubscriber: boolean;
  canResumePausedSubscription: boolean;
  trial: {
    accessDaysRemaining?: number;
    dateToCharge?: string;
    expiredFromTrial?: boolean;
    paidThroughDate?: string;
  };
}

export interface UpdateUserParams {
  user: {
    name: string;
    email: string;
    password?: string;
  };
}

export interface UpdateUserResponse {
  emailVerificationRequired?: boolean;
  message?: string;
  error?: string;
}

export interface GiftSubscriptionReponse {
  offer: {
    initialPrice: number;
  };
}

export interface EmailSettings {
  articleNotifications: string;
  commentNotificationEnabled: boolean;
  sendEventEmails: boolean;
  sendForumDigest: boolean;
  sendPromotionEmails: boolean;
  sendProductEmails: boolean;
  surveyEnabled: boolean;
  weeklyDigestEmails: boolean;
  weeklyDigestEnabled: boolean;
}

export interface EmailSettingsParams {
  user: {
    article_notifications?: string;
    comment_notification_enabled?: boolean;
    send_event_emails?: boolean;
    send_forum_digest?: boolean;
    send_promotion_emails?: boolean;
    send_product_emails?: boolean;
    survey_enabled?: boolean;
  };
}

export interface AffiliateSettingsParams {
  payment_id: string;
  payment_type: string;
}

export interface AffiliateSettings {
  paymentId?: string;
  paymentType: {
    label?: string;
    value?: string;
  };
}

export async function getUserSetting(): Promise<SettingsResponse> {
  const resp = await request('get', api_user_account_path());
  return resp;
}

export async function giftSubscriptionSettings(): Promise<GiftSubscriptionReponse> {
  const resp = await request('get', api_gift_subscription_settings_path());
  return resp;
}

export async function getEmailSettings(): Promise<EmailSettings> {
  const resp = await request('get', api_email_settings_path(getJWT()));
  return resp;
}

export async function updateEmailSettings(params: EmailSettingsParams): Promise<SuccessResponse> {
  const resp = await request('put', api_update_email_settings_path({ ...params, ...getJWT() }));
  return resp;
}
